import { useState, useEffect } from "react";
import EmptyModel from "../../../../components/modal/emptyModal";
import HeaderBar from "../../../../components/header/headerBar";
import MainButton from "../../../../components/button/mainButton";
import { useHistory } from "react-router";

import { useParams } from "react-router-dom";
import axios from "axios";

import { Icon } from "@iconify/react";
import {
  Input,
  Form,
  Modal,
  Select,
  Space,
  Button,
  Row,
  Col,
  Table,
  message,
} from "antd";
import ModalJobGroups from "../../../../components/antd/modalJobgroups";

const JobGroupCategory = () => {
  interface ParamTypes {
    id: string;
  }

  const { confirm } = Modal;
  const { id } = useParams<ParamTypes>();
  let [formJobGroups] = Form.useForm();
  const { Option } = Select;
  const history = useHistory();

  const [isOpen, setIsOpen] = useState(false);
  const [optCal, setOptCal] = useState<any>([]);
  const [updateId, setupdateId] = useState<string>("");
  const [typeJob, setTypeJob] = useState<any>("");
  const [dataJobGroups, setdataJobGroups] = useState<any>([]);
  const [categoryType, setcategoryType] = useState<any>("");
  const columns = [
    {
      title: "",
      dataIndex: "",
      render: (text: any, record: any, index: number) => {
        return <a>{index + 1}</a>;
      },
    },
    {
      dataIndex: "name",
      title: "Job Title",
    },
    {
      title: "ค่ามือ/Com (Bath 1Hr)",
      dataIndex: "handFeeCom1Hr",
      align: "right" as const,
    },
    {
      title: "ค่ามือ/Com (Bath 2Hr)",
      dataIndex: "handFeeCom2Hr",
      align: "right" as const,
    },
    {
      title: "ค่ามือ/Com (Bath 3Hr)",
      dataIndex: "handFeeCom3Hr",
      align: "right" as const,
    },
    {
      title: "Action",
      align: "center" as const,
      width: "10%",
      render: (text: any, record: any) => {
        return (
          <div onClick={() => showDeleteConfirm(record)}>
            <Icon
              icon="icomoon-free:bin"
              width="20"
              height="20"
              color="#FF6760"
            />
          </div>
        );
      },
    },
  ];

  function onClose() {
    setIsOpen(false);
  }

  const getData = () => {
    axios.get(`/job-groups?productCategoryId=${id}`).then((res) => {
      console.log("data=>>>>>", res.data);
      setcategoryType(res?.data?.category?.name);
      if (res?.data?.data === null) {
        setTypeJob("Create");
      } else {
        setTypeJob("Update");
        getDataOne(id);
      }

      // console.log("TypeJob", typeJob);

      // setSubCategory(res.data.data);
    });
  };

  const creatData = async (value: any) => {
    console.log("dddd", dataJobGroups);

    try {
      await axios
        .post(`/job-groups?productCategoryId=${id}`, {
          agent: value?.agent,
          commission: value?.commission,
          operatingRoomFee: value?.operatingRoomFee,
          calculatedFrom: value?.calculatedFrom,
          jobTitles: dataJobGroups,
        })
        .then((res) => {
          setTimeout(() => message.success("Create Success"), 300);
          history.push(`/setting/service/category`);
        });
    } catch (err) {
      console.log(err);
      return;
    }
  };

  const getDataOne = async (dataId: any) => {
    try {
      await axios.get(`/job-groups?productCategoryId=${dataId}`).then((res) => {
        console.log("dataId", dataId);

        let data = res?.data?.data;
        console.log("data", data);

        setupdateId(data?._id);
        setdataJobGroups(data.jobTitles);
        formJobGroups.setFieldsValue({
          agent: data?.agent,
          commission: data?.commission,
          operatingRoomFee: data?.operatingRoomFee,
          calculatedFrom: data?.calculatedFrom,
        });
      });
    } catch (err) {
      console.log(err);
      return;
    }
  };
  const updateData = async (data: any) => {
    const arrJobs = dataJobGroups.map(
      (datajob: any, index: number) => datajob._id
    );

    // console.log("arrJobs", arrJobs);

    try {
      await axios
        .patch(`/job-groups?productCategoryId=${id}`, {
          agent: data?.agent,
          commission: data?.commission,
          operatingRoomFee: data?.operatingRoomFee,
          calculatedFrom: data?.calculatedFrom,
          jobTitles: arrJobs,
        })
        .then((res) => {
          setTimeout(() => message.success("Update Success"), 300);
          history.push(`/setting/service/category`);
        });
    } catch (err) {
      console.log(err);
      return;
    }
  };

  function showDeleteConfirm(value: any) {
    confirm({
      title: "",
      content: (
        <>
          <div>
            <Icon
              icon="lucide:alert-circle"
              color="#FF6760"
              width="10.6%"
              height="10.6%"
              style={{ marginBottom: "28px" }}
            />
          </div>
          <div>{`ต้องการลบ ${value?.name} ออกหรือไม่ ?`}</div>
          <div>{`Are you sure delete ${value?.name} from list?`}</div>
        </>
      ),
      // content: "Some descriptions",
      autoFocusButton: null,
      okText: "ตกลง / Submit",
      okType: "danger",
      cancelText: "ยกเลิก / Cancel",
      onOk() {
        deleteData(value);
      },
      width: "fit-content",
    });
  }

  const deleteData = (name: any) => {
    const xdelete = dataJobGroups.filter(
      (x: any, i: number) => x._id !== name._id
    );
    setdataJobGroups(xdelete);
  };

  const dataReturnJob = (data: any) => {
    console.log("dataReturn", data);

    // console.log("xData", xData);

    const x_add = dataJobGroups.find((x: any, i: number) => x._id === data._id);

    console.log("x_add", x_add);
    if (x_add == undefined) {
      const xData = dataJobGroups.map((datajob: any, index: number) => ({
        ...datajob,
      }));
      xData.push(data);
      setdataJobGroups(xData);
    } else {
      message.error("เลือกซ้ำ / You Have Already  Items ");
    }
  };

  const OnSubmit = (values: any) => {
    if (dataJobGroups?.length === 0) {
      message.error("กรุณาเลือกรายการ Please Select Items");
      return;
    }

    if (typeJob === "Create") {
      creatData(values);
    } else if (typeJob === "Update") {
      updateData(values);
    }

    // creatData(values);
  };

  const getCalculated = () => {
    let cal = [
      {
        value: "sale_price",
        name: "ราคาขาย/Sale Price",
      },
      {
        value: "free_rate",
        name: "ตามอัตรา/Fee Rate",
      },
      {
        value: "amount_used",
        name: "จำนวนที่ใช้/Amount Used",
      },
    ];

    const xCal = [];
    for (let i = 0; i < cal.length; i++) {
      xCal.push(
        <Option value={cal[i]?.value} key={cal[i]?.value}>
          {cal[i]?.name}
        </Option>
      );
    }
    setOptCal(xCal);
  };
  useEffect(() => {
    getData();
    getCalculated();
  }, []);

  useEffect(() => {
    console.log("dataJobGroups", dataJobGroups);
  }, [dataJobGroups]);

  useEffect(() => {
    console.log("typeJob", typeJob);
  }, [typeJob]);

  return (
    <div>
      <HeaderBar title={"CATEGORY / " + categoryType} btnBack />
      <Form form={formJobGroups} onFinish={OnSubmit}>
        <div style={{ padding: "10px 40px" }}>
          <div className="card-view" style={{ padding: 20 }}>
            <label style={{ fontWeight: 600, fontSize: 20 }}>
              สร้างส่วนค่าใช้จ่าย/Create Cost
            </label>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: 10,
              }}
            >
              <div
                className="row justify-center  mt-20"
                style={{ width: "30%" }}
              >
                <label
                  style={{
                    color: "#5BAEA9",
                    marginBottom: 15,
                    fontSize: 14,
                    fontWeight: 500,
                  }}
                >
                  หักค่าตัวแทน/Agent(%)
                </label>
                <Form.Item
                  name={"agent"}
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอกข้อมูล!",
                    },
                  ]}
                >
                  <Input type="number" />
                </Form.Item>
              </div>
              <div
                className="row justify-center  mt-20"
                style={{ width: "30%" }}
              >
                <label
                  style={{
                    color: "#5BAEA9",
                    marginBottom: 15,
                    fontSize: 14,
                    fontWeight: 500,
                  }}
                >
                  ค่าคอมมิชชั่น/Commission (Storefront %)
                </label>
                <Form.Item
                  name={"commission"}
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอกข้อมูล!",
                    },
                  ]}
                >
                  <Input type="number" />
                </Form.Item>
              </div>
              <div
                className="row justify-center  mt-20"
                style={{ width: "30%" }}
              >
                <label
                  style={{
                    color: "#5BAEA9",
                    marginBottom: 15,
                    fontSize: 14,
                    fontWeight: 500,
                  }}
                >
                  ค่าห้องผ่าตัด/Operating Room Fee
                </label>
                <Form.Item
                  name={"operatingRoomFee"}
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอกข้อมูล!",
                    },
                  ]}
                >
                  <Input type="number" />
                </Form.Item>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: 10,
              }}
            >
              <div
                className="row justify-center  mt-20"
                style={{ width: "30%" }}
              >
                <label
                  style={{
                    color: "#5BAEA9",
                    marginBottom: 15,
                    fontSize: 14,
                    fontWeight: 500,
                  }}
                >
                  คำนวณจาก/Calculated From
                </label>
                <Form.Item
                  name="calculatedFrom"
                  rules={[
                    {
                      required: true,
                      message: "กรุณาเลือก!",
                    },
                  ]}
                >
                  <Select
                    placeholder={"เลือกจำนวณ"}
                    filterOption={(input: any, option: any) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    showSearch
                  >
                    {optCal}
                  </Select>
                </Form.Item>
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              marginTop: "20px",
            }}
          >
            <ModalJobGroups dataReturn={dataReturnJob}></ModalJobGroups>
          </div>
          <div>
            <Table
              columns={columns}
              dataSource={dataJobGroups}
              bordered
              scroll={{ x: 100 }}
              rowKey="_id"
            />
          </div>
          <Row className="Button-Select" justify="center">
            <Space>
              <Col className="Cancle-Button">
                <Button
                  onClick={() => history.push(`/setting/service/category`)}
                >
                  ยกเลิก/Cancel
                </Button>
              </Col>
              <Col className="Select-Button">
                <Button
                  // onClick={() => history.push(`/opd/so/cart/${id}`)}
                  htmlType="submit"
                >
                  บันทึกข้อมูล/Submit
                </Button>
              </Col>
            </Space>
          </Row>
        </div>
      </Form>
    </div>
  );
};
export default JobGroupCategory;
